<template>
    <div class="  con_content">
        <div class="container">
            <div class="container_top h_48">
                帖子管理
               
            </div>
           
            <div >

                <!-- table组件 -->
                <div class="my_table">
                  
                    <div class="my_search">
                        
                        <Row class="search_row">  
                            <div  class="search_name">                             
                                                            
                                <Button class="mR5"    :type="titles == 3? 'info':null"    @click='titleFun(3)' > 全部</Button>                              
                                <Button class="mR5"    :type="titles == 0? 'info':null"    @click='titleFun(0)' > 视频</Button>                              
                                <Button class="mR5"    :type="titles == 1? 'info':null"    @click='titleFun(1)' > 图文</Button>                              
                                <!-- <Button class="mR5"    :type="titles == 2? 'info':null"    @click='titleFun(2)' > 文字</Button>                               -->
                            </div> 
                        </Row>
                     
                    </div>
                
                
                </div>
                <div class="my_table" >
                  
                    <div class="my_search">
                        
                        <Row class="search_row">  
                            <div  class="search_name">                             
                                <Select v-model="audit"   @on-change="selectFun" style="width:100px;text-align:left" >
                                    <Option v-for="item in selectAll" :value="item.value" :key="item.value">{{ item.label }}</Option>
                                </Select>                           
                                <!-- <Button class="mR5"    :type="audit == 0? 'info':null"    @click='auditFun(0)' > 待审核</Button>                              
                                <Button class="mR5"    :type="audit == 1? 'info':null"    @click='auditFun(1)' > 审核成功</Button>                              
                                <Button class="mR5"    :type="audit == 2? 'info':null"    @click='auditFun(2)' > 审核未通过</Button>                               -->
                            </div> 
                        </Row>
                     
                    </div>
                
                
                </div>
                <!-- table组件 -->
                <div class="my_table "  >
                    <Header class="my_title txt_l">
                        <span class="my_titleL">
                        <Icon class="fw_900 " type="ios-list" size='30'/>     
                            {{titlesName}} 
                        </span>
                        
                        <div class="ct_rgt">
                            
                            <!-- <div class="sta_btn " type="primary"   @click="exportData">导出数据</div> -->
                            
                        </div>
                    </Header>
                    
                    <Table     border :columns="columns1" :data="data1" ref='table'  >
                        

                        <!-- 查看详情 -->
                        <template slot-scope="{ row, index }" slot="look">
                           
                           <Poptip v-if='row.video != "N/A"' trigger="hover"   content="查看视频详情">
                                <Button  type="info" @click="txtFun(row)" icon="md-videocam"></Button>
                           </Poptip>
                           <Poptip v-if='row.video == "N/A"' trigger="hover"   content="查看图片详情">
                                <Button  type="info" @click="txtFun(row)" icon="md-photos"></Button>
                           </Poptip>
                        </template>    
                        
                        
                          
                        <!-- 待审核按钮 -->
                        <template slot-scope="{ row, index }" slot="btn" >
                            
                            <span v-if="audit == 0 " >
                                <Poptip trigger="hover"   content="通过">
                                    <Button class="padlr5" size="small"  @click='route="/layout/circle/content/pass";btn_state = 1;btnFun(row)'  type="success"      icon="md-checkbox-outline"></Button>
                                </Poptip>
                                <Poptip trigger="hover"  content="拒绝">
                                    <Button class="padlr5"  size="small" @click='route="/layout/circle/content/turn";btn_state = 2;btnFun(row)'  type="error"      icon="md-close"></Button>
                                </Poptip>
                            </span>
                            <span v-else-if="audit == 1 " >
                                <Poptip trigger="hover" v-if="row.is_better == 0"  content="推荐"> 
                                    <Button class="padlr5" size="small"  @click='isBetter=1;route="/layout/circle/content/recommend";btn_state = 6;btnFun(row)'  type="success"      icon="md-navigate"></Button>
                                </Poptip>
                                <Poptip trigger="hover" v-if="row.is_better == 1"  content="取消推荐">
                                    <Button class="padlr5" size="small"  @click='isBetter=0;route="/layout/circle/content/recommend";btn_state = 6;btnFun(row)'  type="warning"      icon="md-navigate"></Button>
                                </Poptip>
                                <Poptip trigger="hover"  content="放入回收站">
                                    <Button class="padlr5"  size="small" @click='route="/layout/circle/content/del";btn_state = 8;btnFun(row)'  type="error"      icon="md-trash"></Button>
                                </Poptip>
                            </span>
                            <span v-else-if="audit == 2 " >
                                <Poptip trigger="hover"   content="复审">
                                    <Button class="padlr5" size="small"  @click='route="/layout/circle/content/pass";btn_state = 1;btnFun(row)'  type="success"      icon="md-repeat"></Button>
                                </Poptip>
                                <Poptip trigger="hover"  content="放入回收站">
                                    <Button class="padlr5"  size="small" @click='route="/layout/circle/content/del";btn_state = 8;btnFun(row)'  type="error"      icon="md-trash"></Button>
                                </Poptip>
                            </span>
                        </template>                        
                          
                    </Table>
                    <Footer>
                       <Page  :current.sync="page" :total="total" :page-size='size'    @on-change='change_page' @on-page-size-change='change_size' show-total  show-sizer      />
                    </Footer>
                    
                </div>

            </div>

       </div>

       <!-- 查看详情-->
        <Modal
            v-model="txtM"
            title = "查看详情"
            class-name="vertical-center-modal"
            okText="关闭"
            cancelText=""
            
            closable
            >
            <div v-if='this_guid'>
                <Child  :child_guid='this_guid' :txtM_c='txtM'></Child>
            </div>  
        </Modal>
       
       <!-- 操作弹窗-->
        <Modal
            v-model="btnM"
            title="提示"
            class-name="vertical-center-modal"
            @on-ok="btn_ok"
            @on-cancel="btn_cancel"
            >
            <p>{{btn_content}}</p>
            
        </Modal>
      
        
  </div>
</template>

<script>
    import { mapState,mapMutations,mapGetters } from 'vuex';
    import { format } from 'path';
    import Child from '../../child_vue/report_child.vue';

    export default {
        name:'contents',
        data () {
            return {
                txt:false,
                route: null,
                guid: null,
                titles: 3,   //视频，图文，文字，推荐
                audit: 0,    //待审核，审核成功，审核未通过
                titlesName: "全部",
                btn_content: null,

                //内容
                columns1:[],   
                data1:[],
                total: null,
                page:1,
                size: 20,
                state: 0,
            

                txtM: false,
                this_guid:  null,
                content: null,
                imgM: false,
                look_img: null,

                btnM: false,
                btn_state: 0,
              
                video: null,
                selectAll: [
                    {value: 0,label: "待审核"},
                    {value: 1,label: "审核成功"},
                    {value: 2,label: "审核未通过"}
                ],
                isBetter: 0  //是否已推荐
                
                
            }
        },
     
        watch:{
           
          
        },
        
        computed: {
            
       
        },
        // 子模板
        props: ['child_guid','txtM_c'],
        components: {
            Child
        },
        
        methods: {
           load(){
                let that = this;
                let url;
                that.columns1= [  
                 
                    {title:'所属分类',key:'TopicName2',align:'center',width: '250'},
                    {title:'用户昵称',key:'name2',align:'center',minWidth: 80,maxWidth: 140},
                    {title:'ID',key:'number',align:'center',minWidth: 80,maxWidth: 140},
                    {title:'标题',key:'content',align:'center',minWidth: 200,ellipsis: true,
                        render:(h,params)=>{
                            return h(
                                    'span',
                                        {     
                                        style:{
                        
                                        },
                                        //就是这里加的属性
                                        domProps: {
                                            title: params.row.content
                                        }
                                    },
                                    params.row.content
                                    )
                            
                        }
                    },
                    {title:'查看详情',slot:'look',align:'center',width: 120},
                    {title:'评论数',key:'count',align:'center',minWidth: 60,maxWidth: 100},
                    {title:'点赞数',key:'like_num',align:'center',minWidth: 60,maxWidth: 100},
                    {title:'发布时间',key:'create_time',align:'center',minWidth: 125,maxWidth:200},
                    {title:'操作',slot:'btn',align:'center',width: 130,fixed: 'right'},
                ];
                if(that.titles == 0){    //video
                    url = "admin/service/admin/trend/article/video";
                    
                }else if(that.titles == 1){  //image_and_text
                    url = "admin/service/admin/trend/article/image_and_text";
                    
                }else if(that.titles == 2){   //words
                    url = "admin/service/admin/trend/article/words";
                   
                }else if(that.titles == 3){
                   url = "admin/service/admin/trend/article"; 
                   
                    
                }

                that.$myAjax.get(
                    url+'?page='+that.page+'&size='+that.size+'&state='+that.audit
                ).then(function(res){
                    let list = res.data.data.list;
                    

                    
                   
                    if(list){
                        
                    }else{
                        list = [];
                       
                    }
                    for(let i = 0;  i<list.length;i++){
                        list[i].name2 = list[i].surname + list[i].name;

                       
                     
                    }
                    that.$split(list);
                    that.$data_null.editor(list);   //没有数据的以 N/A 替代
                    
                    that.data1 = list;

                    
                    that.total =  res.data.data.total;
                    
                })
            },
            

            titleFun(num){
                let that = this;
                that.titles = num;
                that.load(num);
                if(num == 0){
                    that.titlesName = "视频管理"
                }else if(num == 1){
                    that.titlesName = "图文管理"
                }else if(num == 2){
                    that.titlesName =  "段子管理"
                }else if(num == 3){
                    that.titlesName =  "全部"
                }
            },
            auditFun(num){
                let that = this;
                that.audit = num;
                that.load();
            },

            change_page(index){
                this.load();
            },
            change_size(size){
                this.size = size;
                this.load();
            },

            // 详细查看
            txtFun(row){
                let that = this;
                that.txtM = true;
                that.this_guid = row.guid;

                
                
            },
           

            txt_ok(){
                this.txtM = false;
            },

             
           

            // 操作按钮
            btnFun(row){
                let that = this;
                
                that.guid = row.guid;
                that.btnM = true;
                switch(that.btn_state){
                    case 0 :
                        that.btn_content = "确定重新审核吗？";
                        break;
                    case 1 :
                        that.btn_content = "确定通过审核吗？";
                        break;
                    case 2 :
                        that.btn_content = "确定拒绝审核吗？";
                        break;
                    case 3 :
                        that.btn_content = "确定屏蔽审核吗？";
                        break;
                    case 7 :
                        that.btn_content = "确定取消推荐吗？";
                        break;
                    case 8 :
                        that.btn_content = "确定放入回收站吗？";
                        break;

                    default :
                        break;
                }
            
                if(that.btn_state == 6 && that.isBetter == 0 ){
                    that.btn_content = "确定取消推荐吗？";
                }else if(that.btn_state == 6 && that.isBetter == 1){
                    that.btn_content = "确定推荐吗？";
                }
            },
            btn_ok(){
                let that = this;
                //btn_state   0 待审核 1审核成功 2审核未通过 3屏蔽    6推荐(1)   7取消推荐(0) 8删除
                if(that.btn_state < 4 ){
                    
                    that.$myAjax.post('admin/service/admin/trend/article/check?route='+that.route,{
                        state:that.btn_state,guid:that.guid
                    }).then( res => {
                        that.load();
                    })
                }else if(that.btn_state >5 && that.btn_state <8){
                   
                    
                    that.$myAjax.put('admin/service/admin/trend/article/better?route='+that.route,{
                    
                        isBetter: that.isBetter,guid:that.guid
                    }).then( res => {
                        that.load();
                    })
                }else if(that.btn_state == 8){
                   
                    that.$myAjax.delete('admin/service/admin/trend/article/display?route='+that.route+'&guid='+that.guid
                      
                    ).then( res => {
                        that.load();
                    })
                }
                
            },
            btn_cancel(){
                this.btn_state = false;
            },
           
            selectFun(){
                this.load()
            },


            
            
         
        },
        mounted: function(){
           let that = this;
           that.load();
           
        }
    }
</script>
<style scoped>
    @import "/css/modal.css";
    #myVideo{
        width: 100% !important;
        height: 220px !important;
    }
    .con_c{
        width: 80%;
        margin-left: 10%;
        height: 300px;
        padding: 10px;
        overflow-y: auto;
        overflow-x: hidden;
        
        border: 1px solid #e8eaec;
        border-radius: 10px;
    }
    .con_txt{
        margin-bottom: 20px;
    }
    .con_img{
        width: 100%;
        position: relative;
        height: auto;
    }
    .con_img img{
        width: calc(100% - 20px);
        
    }
    .t_in{
        text-indent: 20px;
    }
   
</style>




